import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

export const FormAddShop = () => {
  const [loadingSubmit, setloadingSubmit] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    picture: null,
    active: 1,
    FiledDescription: 1,
    FiledTitle: 1,
    FiledImage: 1,
  });

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setFormData((prev) => ({
        ...prev,
        picture: files[0],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    setloadingSubmit(true);
    e.preventDefault();

    const formDataToSend = new FormData();
    for (let key in formData) {
      if (formData[key] !== null) {
        formDataToSend.append(key, formData[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.ShopAds.Add,
        data: formDataToSend,
        isFormData: true,
      });

      setloadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/Shop-ADS");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setloadingSubmit(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        fullWidth
        margin="normal"
        label="Name"
        name="name"
        required
        autoComplete="off"
        value={formData.title}
        onChange={handleInputChange}
        variant="outlined"
      />

      <TextField
        fullWidth
        margin="normal"
        label="Description"
        name="description"
        multiline
        rows={2}
        autoComplete="off"
        value={formData.description}
        onChange={handleInputChange}
        variant="outlined"
      />

      <TextField
        fullWidth
        margin="normal"
        label="Upload Image"
        name="file"
        type="file"
        InputLabelProps={{ shrink: true }}
        onChange={handleInputChange}
        variant="outlined"
        inputProps={{
          accept: "image/*",
        }}
      />

      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="grid grid-cols-1 items-center justify-between gap-x-3">
          <div className="flex items-center justify-start gap-x-3">
            <FormLabel sx={{ fontWeight: "bold" }} component="legend">
              Image Required:
            </FormLabel>
            <RadioGroup
              name="FiledImage"
              value={formData.FiledImage}
              onChange={handleRadioChange}
              row
            >
              <FormControlLabel value="1" control={<Radio />} label="Yes" />
              <FormControlLabel value="0" control={<Radio />} label="No" />
            </RadioGroup>
          </div>

          <div className="flex items-center justify-start gap-x-3">
            <FormLabel sx={{ fontWeight: "bold" }} component="legend">
              Active:
            </FormLabel>
            <RadioGroup
              name="active"
              value={formData.active}
              onChange={handleRadioChange}
              row
            >
              <FormControlLabel value="1" control={<Radio />} label="Yes" />
              <FormControlLabel value="0" control={<Radio />} label="No" />
            </RadioGroup>
          </div>
        </div>

        <div className="grid grid-cols-1 items-center justify-between gap-x-3">
          <div className="flex items-center mt-2 justify-start gap-x-3">
            <FormLabel sx={{ fontWeight: "bold" }} component="legend">
              Description Required:
            </FormLabel>
            <RadioGroup
              name="FiledDescription"
              value={formData.FiledDescription}
              onChange={handleRadioChange}
              row
            >
              <FormControlLabel value="1" control={<Radio />} label="Yes" />
              <FormControlLabel value="0" control={<Radio />} label="No" />
            </RadioGroup>
          </div>

          <div className="flex items-center justify-start gap-x-3">
            <FormLabel sx={{ fontWeight: "bold" }} component="legend">
              Title Required:
            </FormLabel>
            <RadioGroup
              name="FiledTitle"
              value={formData.FiledTitle}
              onChange={handleRadioChange}
              row
            >
              <FormControlLabel value="1" control={<Radio />} label="Yes" />
              <FormControlLabel value="0" control={<Radio />} label="No" />
            </RadioGroup>
          </div>
        </div>
      </div>

      {loadingSubmit ? (
        <Button
          fullWidth
          variant="contained"
          color="primary"
          sx={{
            display: "flex",
            marginTop: 2,
            width: "20%",
            marginX: "auto",
            fontWeight: "bold",
            justifyContent: "center",
          }}
        >
          <CircularProgress size={24} color="inherit" />
        </Button>
      ) : (
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          sx={{
            display: "block",
            marginTop: 2,
            width: "20%",
            marginX: "auto",
            fontWeight: "bold",
          }}
        >
          Submit
        </Button>
      )}
    </form>
  );
};
